const BOOKING_DEFAULT = {
  id: '',
  code: '',
  projectID: '',
  project: {
    printType: 'none',
    maOwnerCompanyBranchID: 0,
  },
  projectUnitID: '',
  customerID: '',
  customerDetailID: '',
  customerDetail: {
    address2: '',
  },
  statusID: '',
  bookingStatus: {
    name: '',
  },
  paymentMethodID: '',
  paymentMethod: {
    name: '',
  },
  paymentTypeID: '',
  paymentType: {
    name: '',
  },
  paymentStatusID: '',
  paymentStatus: {
    name: '',
  },
  paymentAmount: '',
  paymentPictures: [],
  paymentAt: '',
  spaValue: '',
  spaDecimal: '',
  spaFull: '',
  spaTimes: '',
  sellingPrice: '',
  nettSellingPrice: '',
  createdAt: '',
  leadCreatedAt: '',
  leadStatus: '',
  bankCases: [],
  assignedMaName: '',
  assignedMaPreferredName: '',
  assignedMaUserID: 0,
  remarkInternal: '',
  newBookingNoteEncoded: '',
  isCancelPending: true,
  bookingCustomFields: [],
  noeticStatusID: 'none',
  noeticSalesID: '',
  bookingFeePayments: [],
  bookingPaymentPaidCents: 0,
  specifications: [],
  salesPersonSignAt: '',
  bookingAttachments: [],
  linkBuyerApp: false,
  buyerProfileID: '',
  srpLoan: '',
  firstTimeBuyer: '',
  externalID: '',
  externalLeadID: '',
};
export default BOOKING_DEFAULT;



// WEBPACK FOOTER //
// ./src/structs/booking.js